import { Media, MediaTypeId } from 'pricing/types';

export const getMediaContractAmendments = (media: Media[]) => {
  const amendmentsFiles = media.filter(
    (m) => m.mediaTypeId === MediaTypeId.BreederContractAmendment,
  );

  return amendmentsFiles.sort((a, b) => b.uploadedAt.localeCompare(a.uploadedAt));
};

export const getMediaContractFileDataUrl = (media: Media[]) => {
  const contractMedia = media.find((m) => m.mediaTypeId === MediaTypeId.BreederContract);
  return contractMedia?.dataUrl;
};
